module.exports = __webpack_public_path__ + "img/launchpad_app.496d8eb7.svg";